import { render, staticRenderFns } from "./app-upload-drag.vue?vue&type=template&id=2bdf8119&scoped=true"
import script from "./app-upload-drag.vue?vue&type=script&lang=js"
export * from "./app-upload-drag.vue?vue&type=script&lang=js"
import style0 from "./app-upload-drag.vue?vue&type=style&index=0&id=2bdf8119&prod&lang=scss"
import style1 from "./app-upload-drag.vue?vue&type=style&index=1&id=2bdf8119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf8119",
  null
  
)

export default component.exports